import BaseButton from "Components/Base/BaseButton";
import BaseInput from "Components/Base/BaseInput";
import { BaseSelect } from "Components/Base/BaseSelect";
import {
  InputPlaceHolder,
  SelectPlaceHolder,
} from "Components/constants/validation";
import React from "react";
import { FormikProps } from "formik";
import { WorkOrderLabel } from "Components/constants/WorkOrder";
import { TaxType } from "Components/constants/Common";
interface FormFieldsProps {
  formik: FormikProps<any>;
  quotationOption: any;
  workOrderId: any;
  viewWorkOrderMode: boolean;
  setQuotation: any;
  setInitialValue:any;
}
const FormFields: React.FC<FormFieldsProps> = ({
  formik,
  quotationOption,
  workOrderId,
  viewWorkOrderMode,
  setQuotation,
  setInitialValue,
}) => {
  return (
    <form onSubmit={formik.handleSubmit} className="mt-2 mb-4">
      <div className="row">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseSelect
            name="quoteNo"
            label={WorkOrderLabel.QuoteNo}
            options={quotationOption}
            placeholder={SelectPlaceHolder(WorkOrderLabel.QuoteNo)}
            value={formik.values.quoteNo}
            handleChange={(field: any, value: any) => {
              formik.setFieldValue(field, value);
              setQuotation(false);
              setInitialValue(false);
            }}
            handleBlur={formik.handleBlur}
            error={formik.errors.quoteNo}
            touched={formik.touched.quoteNo}
            isDisabled={workOrderId}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vendorName"
            label={WorkOrderLabel.VendorName}
            placeholder={InputPlaceHolder(WorkOrderLabel.VendorName)}
            value={formik.values.vendorName}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorName}
            touched={formik.touched.vendorName}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vendorId"
            label={WorkOrderLabel.VendorId}
            placeholder={InputPlaceHolder(WorkOrderLabel.VendorId)}
            value={formik.values.vendorId}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorId}
            touched={formik.touched.vendorId}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="quoteAmountExl"
            label={WorkOrderLabel.QuoteAmtExl}
            placeholder={InputPlaceHolder(WorkOrderLabel.QuoteAmtExl)}
            value={formik.values.quoteAmountExl}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.quoteAmountExl}
            touched={formik.touched.quoteAmountExl}
            disabled={true}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="quoteAmountInc"
            label={WorkOrderLabel.QuoteAmtInc}
            placeholder={InputPlaceHolder(WorkOrderLabel.QuoteAmtInc)}
            value={formik.values.quoteAmountInc}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.quoteAmountInc}
            touched={formik.touched.quoteAmountInc}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="quoteDate"
            type="date"
            label={WorkOrderLabel.QuotationDate}
            placeholder={InputPlaceHolder(WorkOrderLabel.QuotationDate)}
            value={formik.values.quoteDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.quoteDate}
            touched={formik.touched.quoteDate}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="text"
            name="workOrderNo"
            label={WorkOrderLabel.WorkOrderNo}
            placeholder={InputPlaceHolder(WorkOrderLabel.WorkOrderNo)}
            value={formik.values.workOrderNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.workOrderNo}
            touched={formik.touched.workOrderNo}
            disabled={workOrderId}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="workOrderAmtExl"
            label={WorkOrderLabel.WorkOrderAmtExl}
            placeholder={InputPlaceHolder(WorkOrderLabel.WorkOrderAmtExl)}
            value={formik.values.workOrderAmtExl}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.workOrderAmtExl}
            touched={formik.touched.workOrderAmtExl}
            disabled={true}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="gstAmount"
            label={WorkOrderLabel.GstAmount}
            placeholder={InputPlaceHolder(WorkOrderLabel.GstAmount)}
            value={formik.values.gstAmount}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.gstAmount}
            touched={formik.touched.gstAmount}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="workOrderAmtInc"
            label={WorkOrderLabel.WorkOrderAmtInc}
            placeholder={InputPlaceHolder(WorkOrderLabel.WorkOrderAmtInc)}
            value={formik.values.workOrderAmtInc}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.workOrderAmtInc}
            touched={formik.touched.workOrderAmtInc}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="difference"
            label={WorkOrderLabel.Difference}
            placeholder={InputPlaceHolder(WorkOrderLabel.Difference)}
            value={formik.values.difference}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.difference}
            touched={formik.touched.difference}
            tooltip={true}
            tooltipIcon="help-circle-outline"
            tooltipIconColor="info"
            tooltipText={WorkOrderLabel.DifferenceDes}
            required
            disabled={true}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="warranty"
            label={WorkOrderLabel.Warranty}
            placeholder={InputPlaceHolder(WorkOrderLabel.Warranty)}
            value={formik.values.warranty}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.warranty}
            touched={formik.touched.warranty}
            disabled={viewWorkOrderMode}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="workOrderDate"
            type="date"
            label={WorkOrderLabel.WorkOrderDate}
            placeholder={InputPlaceHolder(WorkOrderLabel.WorkOrderDate)}
            value={formik.values.workOrderDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.workOrderDate}
            touched={formik.touched.workOrderDate}
            disabled={viewWorkOrderMode}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="remarks"
            label={WorkOrderLabel.Remarks}
            placeholder={InputPlaceHolder(WorkOrderLabel.Remarks)}
            value={formik.values.remarks}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.remarks}
            touched={formik.touched.remarks}
            disabled={viewWorkOrderMode}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="discount"
            label={WorkOrderLabel.Discount}
            placeholder={InputPlaceHolder(WorkOrderLabel.Discount)}
            value={formik.values.discount}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.discount}
            touched={formik.touched.discount}
            disabled={true}
          />
        </div>
        {workOrderId && (
          <>
            <div className="col-md-3 col-sm-6 col-12">
              <BaseInput
                name="woStatus"
                label={WorkOrderLabel.Status}
                placeholder={InputPlaceHolder(WorkOrderLabel.Status)}
                value={formik.values.woStatus}
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                error={formik.errors.woStatus}
                touched={formik.touched.woStatus}
                disabled={true}
              />
            </div>
            <div className="col-md-3 col-sm-6 col-12">
              <BaseInput
                name="isGenerated"
                label={WorkOrderLabel.TaxInvoice}
                placeholder={InputPlaceHolder(WorkOrderLabel.TaxInvoice)}
                value={formik.values.isGenerated ? WorkOrderLabel.Generated : WorkOrderLabel.Pending}
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                error={formik.errors.isGenerated}
                touched={formik.touched.isGenerated}
                disabled={true}
              />
            </div>
          </>
        )}
      </div>
    </form>
  );
};

export default FormFields;
